const mutations = {
  onGetInspectionsFilter (state, payload) {
    let data = payload.response.data.data
    // El backend puede devolver la página como objeto con llaves numéricas ({"1": {...}}) en vez de arreglo
    payload.event.context.report = Array.isArray(data.data) ? data.data : Object.values(data.data || {})
    payload.event.context.optionsDataTable.totalItems = data.total
    payload.event.context.optionsDataTable.total = data.total
    payload.event.context.optionsDataTable.page = data.current_page
    payload.event.context.loadingTable = false
  },
  onGetInspectionsFilterDoc (state, payload) {
    payload.event.context.forceFileDownload(payload.response.data, `${payload.event.context.$t('reports.InspectionsByUnitType')}-${new Date().toISOString().substr(0, 10)}.csv`)
    payload.event.context.loadingButton = false
  },
  onGetInspectionInspector (state, payload) {
    let data = payload.response.data.data
    payload.event.context.report2 = data.data
    payload.event.context.optionsDataTable.totalItems = data.total
    payload.event.context.optionsDataTable.total = data.total
    payload.event.context.optionsDataTable.page = data.current_page
    payload.event.context.loadingTable = false
  },
  onGetInspectionInspectorDoc (state, payload) {
    payload.event.context.forceFileDownload(payload.response.data, `${payload.event.context.$t('reports.InspectionsByInspector')}-${new Date().toISOString().substr(0, 10)}.csv`)
    payload.event.context.loadingButton = false
  },
  onGetIncidentsInspector (state, payload) {
    let data = payload.response.data.data
    payload.event.context.report3 = data.data
    payload.event.context.optionsDataTable.totalItems = data.total
    payload.event.context.optionsDataTable.total = data.total
    payload.event.context.optionsDataTable.page = data.current_page
    payload.event.context.loadingTable = false
  },
  onGetIncidentsInspectorDoc (state, payload) {
    payload.event.context.forceFileDownload(payload.response.data, `${payload.event.context.$t('reports.IncidentsByInspector')}-${new Date().toISOString().substr(0, 10)}.csv`)
    payload.event.context.loadingButton = false
  },
  onGetcheckList (state, payload) {
    let data = payload.response.data.data
    payload.event.context.report4 = data.data
    payload.event.context.optionsDataTable.totalItems = data.total
    payload.event.context.optionsDataTable.total = data.total
    payload.event.context.optionsDataTable.page = data.current_page
    payload.event.context.loadingTable = false
  },
  onGetcheckListDoc (state, payload) {
    payload.event.context.forceFileDownload(payload.response.data, `${payload.event.context.$t('reports.ChecklistReport')}-${new Date().toISOString().substr(0, 10)}.csv`)
    payload.event.context.loadingButton = false
  },
  onGetInspectionUnitType (state, payload) {
    let data = payload.response.data.data
    payload.event.context.report5 = data.data
    payload.event.context.optionsDataTable.totalItems = data.total
    payload.event.context.optionsDataTable.total = data.total
    payload.event.context.optionsDataTable.page = data.current_page
    payload.event.context.loadingTableInspection = false
  },
  onGetInspectionUnitTypeDoc (state, payload) {
    payload.event.context.forceFileDownload(payload.response.data, `${payload.event.context.$t('reports.IncidentsByUnit')}-${new Date().toISOString().substr(0, 10)}.csv`)
    payload.event.context.loadingButton = false
  },
  onGetQuestionnaires (state, payload) {
    payload.event.context.reports = payload.response.data.data.data
    payload.event.context.loadingTable = false
  },
  onGetInspectionPointsWithDamages (state, payload) {
    let data = payload.response.data.data
    payload.event.context.reportData = data.data
    payload.event.context.optionsDataTable.totalItems = data.total
    payload.event.context.optionsDataTable.total = data.total
    payload.event.context.optionsDataTable.page = data.current_page
    payload.event.context.loadingTable = false
  },
  onGetInspectionPointsWithDamagesDoc (state, payload) {
    let fileName = `${payload.event.context.$t('reports.inspectionPointsWithDamagesDoc')}-${new Date().toISOString().substr(0, 10)}.csv`
    payload.event.context.forceFileDownload(payload.response.data, fileName)
    payload.event.context.loadingButton = false
  },
  onGetOperatorCountDamaged (state, payload) {
    let data = payload.response.data.data
    payload.event.context.reportOperators = data.data 
    payload.event.context.optionsDataTable.totalItems = data.total
    payload.event.context.optionsDataTable.total = data.total
    payload.event.context.optionsDataTable.page = data.current_page
    payload.event.context.loadingTable = false
  },
  onGetOperatorCountDamagedDoc (state, payload) {
    let fileName = `${payload.event.context.$t('reports.operatorsWithDamages')}-${new Date().toISOString().substr(0, 10)}.csv`
    payload.event.context.forceFileDownload(payload.response.data, fileName)
    payload.event.context.loadingButton = false
  },
  onGetInspectionUnitTypeIndexDoc (state, payload) {
    payload.event.context.forceFileDownload(payload.response.data, `${payload.event.context.$t('reports.incidentsUnitTypes')}-${new Date().toISOString().substr(0, 10)}.csv`)
    
    payload.event.context.loadingButtonGeneral = false
  },
  onGetInspectionCountByUnit (state, payload) {
    let data = payload.response.data.data
    payload.event.context.reportUnits = data.data
    payload.event.context.totalItems = data.total
    payload.event.context.loadingTable = false
  },
  onGetInspectionCountByUnitDoc (state, payload) {
    let fileName = `${payload.event.context.$t('reports.inspectionCountByUnitDoc')}-${new Date().toISOString().substr(0, 10)}.xlsx`
    payload.event.context.forceFileDownload(payload.response.data, fileName)
    payload.event.context.loadingButton = false
  },
  onGetInspectionCountByUnitDetails (state, payload) {
    let data = payload.response.data.data
    payload.event.context.inspections = data.data
    payload.event.context.totalItems = data.total
    payload.event.context.loadingTable = false
  },
  onGetTireChangeReport (state, payload) {
    let data = payload.response.data.data
    payload.event.context.reportUnits = data.items || []
    payload.event.context.totalItems = data.pagination ? data.pagination.total : 0
    payload.event.context.loadingTable = false
  },
  onGetTireChangeReportDoc (state, payload) {
    let fileName = `${payload.event.context.$t('reports.tireChangeReportDoc')}-${new Date().toISOString().substr(0, 10)}.csv`
    payload.event.context.forceFileDownload(payload.response.data, fileName)
    payload.event.context.loadingButton = false
  },
  onGetTireChangeReportDetails (state, payload) {
    let data = payload.response.data.data
    payload.event.context.inspections = data.items || []
    payload.event.context.totalItems = data.pagination ? data.pagination.total : 0
    payload.event.context.loadingTable = false
  },
}

export default mutations